import { render, staticRenderFns } from "./edit-panel.vue?vue&type=template&id=2193f7b1&scoped=true&"
import script from "./edit-panel.vue?vue&type=script&lang=js&"
export * from "./edit-panel.vue?vue&type=script&lang=js&"
import style0 from "./edit-panel.vue?vue&type=style&index=0&id=2193f7b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2193f7b1",
  null
  
)

export default component.exports